export enum ContactCommentTypeEnum {
  COMMENT = 'COMMENT',
  REQUEST_CHANGES = 'REQUEST_CHANGES'
}
